import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const damApi = createApi({
    reducerPath: "core/dam",
    baseQuery: axiosBaseQuery,
    tagTypes: ["damList"],
    endpoints: (builder) => ({
        damFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['damList'],
            query: (query = '') => ({
                url: "/core/dam" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        damCreate: builder.mutation({
            invalidatesTags: ['damList'],
            query: (data) => ({
                url: `/core/dam`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        damUpdate: builder.mutation({
            invalidatesTags: ['damList'],
            query: (data) => ({
                url: `/core/dam/${data.get('id')}`,
                method: "PUT",
                data, 
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        damDelete: builder.mutation({
            invalidatesTags: ['damList'],
            query: (id) => ({ url: "/core/dam/" + id, method: "DELETE" })
        }),
    })
})

export const { useDamFindAllQuery, useDamCreateMutation, useDamUpdateMutation, useDamDeleteMutation } = damApi;
export { damApi };
